import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex align-items-center justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WTitle = _resolveComponent("WTitle")!
  const _component_PColumn = _resolveComponent("PColumn")!
  const _component_PDataTable = _resolveComponent("PDataTable")!
  const _component_PCard = _resolveComponent("PCard")!

  return (_openBlock(), _createBlock(_component_PCard, { class: "min-h-screen" }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_WTitle, { text: "Logs" })
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_component_PDataTable, {
        alwaysShowPaginator: false,
        highlightOnSelect: true,
        loading: _ctx.loading,
        resizableColumns: true,
        rowHover: true,
        rows: 300,
        rowsPerPageOptions: [300, 500, 1000],
        sortOrder: -1,
        stripedRows: true,
        value: _ctx.list,
        "data-key": "pid",
        paginator: "",
        paginatorPosition: "both",
        size: "small",
        sortField: "time"
      }, {
        empty: _withCtx(() => [
          _createTextVNode("No records found.")
        ]),
        default: _withCtx(() => [
          _createVNode(_component_PColumn, {
            bodyClass: "text-left vertical-align-top py-0",
            class: "justify-content-center",
            field: "time",
            header: "Time",
            style: {"width":"230px"}
          }),
          _createVNode(_component_PColumn, {
            bodyClass: "text-left vertical-align-top py-0",
            class: "justify-content-center",
            field: "user",
            header: "User",
            style: {"width":"100px"}
          }),
          _createVNode(_component_PColumn, {
            bodyClass: "text-left vertical-align-top text-wrap py-0",
            class: "justify-content-center",
            field: "message",
            header: "Message"
          })
        ]),
        _: 1
      }, 8, ["loading", "value"])
    ]),
    _: 1
  }))
}